module.exports = __webpack_public_path__ + "fonts/f8127b6.otf";